/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-15 13:55:12
 * @LastEditors: linxi
 * @LastEditTime: 2024-11-14 16:29:34
 */
import { CaretDownFilled, CloseOutlined, ExclamationCircleOutlined, QuestionCircleTwoTone } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  Radio,
  Row,
  Select,
  notification,
  Input,
  Tooltip,
  Tabs,
  Divider,
  Switch,
} from 'antd'
import React, { ReactElement, useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import {
  Settinglable,
  PreferencesSet,
  getTemPlateName,
  Checks,
  getCheckName,
} from '../../../models/personalSetting'
import {
  EditableRecipeCategories,
  EditableRecipeCategoriesWithTcmApply,
  getRecipeCategoryName,
  getSortRecipeCategoryName,
  RecipeCategory,
  ToothEditableRecipeCategories,
} from '../../../models/recipe'
import {
  getAllPersonalPreferences,
  getUserProfileList,
  getUserProfileListMessage,
  medicalHistorySaveSettingAsync,
  saveSetting,
} from '../../personalManagement/personalDetail/personalDetailSlice'
import _, { set } from 'lodash'
import styles from './Diagnosis.module.css'
import {
  selectCredentials,
  selectEdition,
  selectStationCategory,
  selectTenantCategory,
  selectTenantCountyCode,
  selectTenantId,
  selectTenantName,
  selectUserId
} from '../../../app/applicationSlice'
import { useQuery } from '../../../utils/HttpUtils'
import { RecipeItemInput } from '../editor/components/RecipeItemInput'
import { ThemeContext } from '../../../theme/ThemeContext'
import { TabPane } from '../../../compnents/widgets/TabBar'
import { normalizeMedicalHistoryFields } from '../medicalHistoryFieldUtils'
import { selectSettings } from "../../user/setting/settingSlice";
import { Checks as SettingChecks } from '../../../models/setting'
import { EditableList } from '../../../compnents/list/EditableList'

const { Option } = Select

interface PreferencesSetModalProps {
  tabNum: string
  isModalVisible: boolean
  userIdRow?: string | undefined
  userName?: string | undefined
  handleCancel: () => void
  onsubmit: () => void
}
export const PreferencesSetModal = ({
  tabNum,
  isModalVisible,
  userIdRow,
  userName,
  handleCancel,
  onsubmit,
}: PreferencesSetModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const settings = useSelector(selectSettings)

  const tenantId = useSelector(selectTenantId)

  const tenantName = useSelector(selectTenantName)

  const tenantCategory = useSelector(selectTenantCategory)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [DefaultRecipeCategories, setDefaultRecipeCategories] = useState<any>([])

  const [formData, setFormData] = useState<any>([])

  const [checkData, setCheckData] = useState<any>([])

  const [btnLoading, setBtnLoading] = useState(false)

  const theme = useContext(ThemeContext)

  const [selectedDiseases, setSelectedDiseases] = useState<any[]>([])

  const [ewfyInput, setEwfyInput] = useState('')

  const [functionsFieldConfig, setFunctionsFieldConfig] = useState<any[]>([])

  const [activeKey, setActiveKey] = useState('1')
  const [tyblFlag, setTyblFlag] = useState(false)
  const [zymrblFlag, setZymrblFlag] = useState(false)
  const [kqblFlag, setKqblFlag] = useState(false)

  // 176中药贴敷方
    const RecipeCategories = hisVersion == 1 ? ToothEditableRecipeCategories
      : (settings?.[176]) ? EditableRecipeCategoriesWithTcmApply : EditableRecipeCategories

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
  }

  useEffect(() => {
    if (isModalVisible) {
      setTyblFlag(formData?.includes(1))
      setZymrblFlag(formData?.includes(2))
      setKqblFlag(formData?.includes(3))
      setActiveKey(formData?.includes(1) ? '1' : formData?.includes(2) ? '2' : formData?.includes(3) ? '3' : '1')
    }
  }, [formData, isModalVisible])

  // 默认需要回填上次就诊病历信息的8个字段key
  const defaultMedicalRecordKeys = [
    'historyOfPresentIllness',
    'pastMedicalHistory',
    'allergen',
    'personalHistory',
    'familyHistory',
    'vaccineHistory',
    'menstrualHistory',
    'maritalHistory',
  ]

  const getShowData = () => {
    dispatch(getUserProfileListMessage({ userId: userIdRow || userId, flag: 1 }))
      .then(unwrapResult)
      .then((v: any) => {
        const records = v?.records || []
        const functionsFieldConfig = v?.functionsFieldConfig || []
        setCheckData(records)
        setFunctionsFieldConfig(functionsFieldConfig?.map((t: any) => {
          const fields = t?.fields?.filter((val: any) => !(val?.isNotModified && !val?.isVisible)) || []
          return { ...t, fields: fields.map((f: any) => ({
            ...f,
            isShowMedicalRecord: f.isShowMedicalRecord !== undefined ? f.isShowMedicalRecord : defaultMedicalRecordKeys?.includes(f.key),
          }))}
        }))
      })
  }

  useEffect(() => {
    if (isModalVisible) {
      getShowData()
    }
  }, [isModalVisible])

  useEffect(() => {
    if (checkData?.length) {
      const ZdblszValue = checkData?.filter((v: any) => v?.code == '1')?.[0]?.codeName //选择要开通的病历

      const ZdblszValueList = ZdblszValue ? ZdblszValue?.split(',')?.filter((v: any) => v != '5' && v != '6')?.map(Number) : []

      setFormData(ZdblszValueList)
    }
  }, [checkData])

  useEffect(() => {
    //选择要开通的病历 联动
    const MRBL = form.getFieldValue([Checks.MRBL])
    !formData?.some((item: any) => item == MRBL) &&
      form.setFieldsValue({
        [Checks.MRBL]: formData?.[0], //默认病历选择开通的病历(formData)中的第一个
      })
  }, [formData])

  useEffect(() => {
    if (isModalVisible) {
      const tabNums = localStorage.getItem('tabNum')

      const ZdblszValue = checkData?.filter((v: any) => v?.code == '1')?.[0]
        ?.codeName //选择要开通的病历

      const temp = ZdblszValue ? ZdblszValue?.split(',')?.filter((v: any) => v == '5' || v == '6')?.map(Number) : [] //开通其他模块

      const XzyktdcfList = checkData?.filter((v: any) => v?.code == '15') //选择要开通的处方

      const XzyktdcfValue = XzyktdcfList?.[0]?.codeName //选择要开通的处方

      const XzyktdcfValueList = settings?.[176] ? XzyktdcfValue?.split(',').map(Number)  : XzyktdcfValue?.split(',').map(Number) ?.filter((v: any) => v != 15)

      const list = XzyktdcfList?.length ? (XzyktdcfValue ? XzyktdcfValueList : []) : RecipeCategories

      const MrcfszList = checkData?.filter((v: any) => v?.code == '2') //开方时默认自动创建处方

      const MrcfszValue = MrcfszList?.[0]?.codeName //开方时默认自动创建处方

      // 口腔默认勾选处置项目
      const KQMrcfszValue = MrcfszList?.length ? (MrcfszValue ? MrcfszValue?.split(',').map(Number) : []) : [13]

      // 通用默认勾选西药方、中药方、治疗
      const ElseMrcfszValue = MrcfszList?.length ? (MrcfszValue ? MrcfszValue?.split(',').map(Number) : []) : [1, 3, 4]

      const MRBLValue = checkData?.filter((v: any) => v?.code == '6')?.[0]
        ?.codeName //选择一个默认病历

      const MRtsValue = checkData?.filter((v: any) => v?.code == '8')?.[0]
        ?.codeName //中药默认帖数

      const EwfyList = checkData?.filter((v: any) => v?.code == '9') //开方自动生成额外费用

      const EwfyValue = EwfyList?.[0] //开方自动生成额外费用开关

      const HbfzValue = checkData?.filter((v: any) => v?.code == '11')?.[0]
        ?.codeName //同步同组药品的频次/用法/天数

      form.setFieldsValue({
        [Checks.Zdblsz]: ZdblszValue ? ZdblszValue?.split(',').map(Number) : [],//选择要开通的病历
        temp: temp, //开通其他模块
        [Checks.MRBL]: tabNums ? Number(tabNums) : Number(MRBLValue), //选择一个默认病历
        [Checks.XZYKTDCF]: list,  //选择要开通的处方
        [Checks.Mrcfsz]: hisVersion == 1 ? KQMrcfszValue : ElseMrcfszValue, //开方时默认自动创建处方
        [Checks.Hbfz]: HbfzValue == 'true' ? true : false, //同步同组药品的频次/用法/天数
        [Checks.MRts]: MRtsValue && MRtsValue != 'false' ? MRtsValue : 7, //中药默认帖数
        [Checks.Ewfy]: [Number(EwfyValue?.switchFlag)], //是否开启方自动生成其他费用
      })
      //是否开启方自动生成其他费用
      setSelectedDiseases(EwfyValue?.codeMap)
      const dataList = list?.slice()
      .sort((a: any, b: any) => getSortRecipeCategoryName(getRecipeCategoryName(a)) - getSortRecipeCategoryName(getRecipeCategoryName(b)))
      setDefaultRecipeCategories(dataList)
    }
  }, [isModalVisible, checkData])

  useEffect(() => {
    if (!isModalVisible) {
      form.resetFields()
    }
  }, [isModalVisible])

  const getAllData = () => {
    // 获取所有的开关配置
    dispatch(getAllPersonalPreferences({ userId: userId }))
      .then(unwrapResult)
      .then((c: any) => {
        const allPersonalPreferences = JSON.stringify(c)
        localStorage.setItem('allPersonalPreferences', allPersonalPreferences)
      })
  }

  return (
    <Modal
      title={`${userName || JSON.parse(localStorage.getItem('credentials') as string)?.userName
        } 偏好设置`}
      width={880}
      footer={null}
      visible={isModalVisible}
      onCancel={() => {
        setEwfyInput('')
        setSelectedDiseases([])
        form.setFieldsValue({ [Checks.Ewfy]: [0] })
        handleCancel()
      }}
      className={styles.modalContent}
    >
      <Form
        form={form}
        {...layout}
        onFinish={(values) => {
          if (!formData?.length) {
            notification.info({
              message: '请至少选择一个病历',
            })
            return
          }
          if (!values?.[Checks.XZYKTDCF]?.length) {
            notification.error({ message: '请选择要开通的处方' })
            return
          }
          if (!values?.[Checks.Mrcfsz]?.length) {
            notification.error({ message: '请选择默认处方设置' })
            return
          }
          values[Checks.Zdblsz] = values.temp
            ? Array.from(new Set([...values.temp, ...values[Checks.Zdblsz]]))
            : [...values[Checks.Zdblsz]]

          const ewfy = (values[Checks.Ewfy]?.[0] == 1 ? '1#' : '0#') + selectedDiseases?.map(v => v.id).join(',')
          const pattern = /^[1-9]*$/
          const f = values && _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
              ({
                code: k,
                codeName:
                  k === Checks.Sc.toString() ? true :
                    k === Checks.Hbfz.toString() ? (v ? true : false) :
                      k === Checks.MRts.toString() ? v?.toString() :
                        k === Checks.Ewfy.toString() ? ewfy :
                          typeof v === 'number' || typeof v === 'string' ? v?.toString() :
                            (v?.length ? v?.join(',') : ''),
                userId: userIdRow || userId,
              } as Settinglable)
            )
            .values()
            .value()
          setBtnLoading(true)

          dispatch(medicalHistorySaveSettingAsync({
            userId: userIdRow || userId,
            fieldConfigs: functionsFieldConfig,
            records: f,
          }))
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '保存成功',
                duration: 3,
              })
              const MRBL = form.getFieldValue([Checks.MRBL])
              localStorage.setItem('tabNum', MRBL == tabNum ? tabNum : MRBL)
              const MRts = form.getFieldValue([Checks.MRts])
              localStorage.setItem('tipsCount', MRts ? MRts : 7)
              getAllData()
              onsubmit()
            })
            .finally(() => {
              setEwfyInput('')
              setSelectedDiseases([])
              form.setFieldsValue({ [Checks.Ewfy]: [0] })
              setBtnLoading(false)
            })
        }}
      >
        <div className={styles.modalMain}>
          {hisVersion == 0 ? (
            <>
              <div className={styles.modalTitle}>开通模块设置</div>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              <Row>
                <Form.Item
                  label='选择要开通的病历'
                  name={Checks.Zdblsz}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group
                    onChange={(e) => {
                      setFormData(e?.filter((v) => v != '5' && v != '6')?.sort((a: any, b: any) => a - b))
                    }}>
                    {PreferencesSet.map((c) => {
                      return (
                        <Checkbox key={c} value={c}>
                          {getTemPlateName(c, tenantCategory)}
                        </Checkbox>
                      )
                    })}
                  </Checkbox.Group>
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label='选择一个默认病历'
                  name={Checks.MRBL}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Radio.Group>
                    {formData?.map((c: any) => {
                      return (
                        <Radio key={c} value={c}>
                          {getTemPlateName(c, tenantCategory)}
                        </Radio>
                      )
                    })}
                  </Radio.Group>
                </Form.Item>
              </Row>
              <Row >
                <Form.Item
                  label='开通其他模块'
                  name='temp'
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group>
                    <Checkbox value={5}>手术申请 </Checkbox>
                    <Checkbox value={6}>手术文书</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Row>
              {/** 惠山区电子病历规范试点，所有电子病例词条均必填且不可修改 **/}
              {(tyblFlag || zymrblFlag || kqblFlag) && (!settings?.[SettingChecks.DZBLCTSD]) ? <>
                <div className={styles.modalTitle}>病历字段设置</div>
                <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
                <Row className={styles.tabsContent}>
                  <Tabs
                    activeKey={activeKey}
                    onChange={(key) => {
                      setActiveKey(key)
                    }}>
                    {tyblFlag ?
                      <TabPane tab='通用病历格式' key='1'>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                          <EditableList
                            dataSource={functionsFieldConfig?.filter((t: any) => t?.templateType === 'TYBL')?.[0]?.fields}
                            bordered={true}
                            pagination={false}
                            columns={[
                              {
                                title: '序号',
                                key: 'no',
                                align: 'center',
                                width: '5rem',
                                render: (_1, _2, i) => `${i + 1}`,
                              },
                              {
                                title: '病历字段',
                                dataIndex: "label",
                                key: "label",
                                align: "left",
                                width: '24rem',
                              },
                              {
                                title: '是否展示',
                                dataIndex: "isVisible",
                                key: "isVisible",
                                align: "center",
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isVisible}
                                      disabled={n.isRequired || n.isNotModified}
                                      onChange={(checked) => {
                                        // 如果必填项已开启或isNotModified为true，则不允许修改
                                        if (n.isRequired || n.isNotModified) {
                                          return
                                        }
                                        const newIsShowMedicalRecord = !checked ? false : n.isShowMedicalRecord
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === 'TYBL' ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isVisible: n?.key === c?.key ? checked : c?.isVisible,
                                                isShowMedicalRecord: n?.key === c?.key ? newIsShowMedicalRecord : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        console.log(checked, data, "checked")
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                              {
                                title: '是否回填上次就诊的病历信息',
                                key: 'isShowMedicalRecord',
                                dataIndex: "isShowMedicalRecord",
                                align: 'center',
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isShowMedicalRecord}
                                      disabled={!n?.isVisible}
                                      onChange={(checked) => {
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === 'TYBL' ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isShowMedicalRecord: n?.key === c?.key ? checked : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        console.log(checked, data, "checked")
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                            ]}
                          />
                        </div>
                      </TabPane> :
                      <></>}
                    {zymrblFlag ?
                      <TabPane tab={tenantCategory == 16 ? '盲人病历格式' : '中医病历格式'} key='2'>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <EditableList
                            dataSource={functionsFieldConfig?.filter((t: any) => t?.templateType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL'))?.[0]?.fields}
                            bordered={true}
                            pagination={false}
                            columns={[
                              {
                                title: '序号',
                                key: 'no',
                                align: 'center',
                                width: '5rem',
                                render: (_1, _2, i) => `${i + 1}`,
                              },
                              {
                                title: '病历字段',
                                dataIndex: "label",
                                key: "label",
                                align: "left",
                                width: '24rem',
                              },
                              {
                                title: '是否展示',
                                dataIndex: "isVisible",
                                key: "isVisible",
                                align: "center",
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isVisible}
                                      disabled={n.isRequired || n.isNotModified}
                                      onChange={(checked) => {
                                        // 如果必填项已开启或isNotModified为true，则不允许修改
                                        if (n.isRequired || n.isNotModified) {
                                          return
                                        }
                                        const newIsShowMedicalRecord = !checked ? false : n.isShowMedicalRecord
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL') ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isVisible: n?.key === c?.key ? checked : c?.isVisible,
                                                isShowMedicalRecord: n?.key === c?.key ? newIsShowMedicalRecord : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        console.log(checked, data, "checked")
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                              {
                                title: '是否回填上次就诊的病历信息',
                                key: 'isShowMedicalRecord',
                                dataIndex: "isShowMedicalRecord",
                                align: 'center',
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isShowMedicalRecord}
                                      disabled={!n?.isVisible}
                                      onChange={(checked) => {
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL') ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isShowMedicalRecord: n?.key === c?.key ? checked : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                            ]}
                          />
                        </div>
                      </TabPane> :
                      <></>
                    }
                    {kqblFlag ?
                      <TabPane tab='口腔病历格式' key='3'>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <EditableList
                            dataSource={functionsFieldConfig?.filter((t: any) => t?.templateType === 'KQBL')?.[0]?.fields}
                            bordered={true}
                            pagination={false}
                            columns={[
                              {
                                title: '序号',
                                key: 'no',
                                align: 'center',
                                width: '5rem',
                                render: (_1, _2, i) => `${i + 1}`,
                              },
                              {
                                title: '病历字段',
                                dataIndex: "label",
                                key: "label",
                                align: "left",
                                width: '24rem',
                              },
                              {
                                title: '是否展示',
                                dataIndex: "isVisible",
                                key: "isVisible",
                                align: "center",
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isVisible}
                                      disabled={n.isRequired || n.isNotModified}
                                      onChange={(checked) => {
                                        // 如果必填项已开启或isNotModified为true，则不允许修改
                                        if (n.isRequired || n.isNotModified) {
                                          return
                                        }
                                        const newIsShowMedicalRecord = !checked ? false : n.newIsShowMedicalRecord
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === 'KQBL' ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isVisible: n?.key === c?.key ? checked : c?.isVisible,
                                                isShowMedicalRecord: n?.key === c?.key ? newIsShowMedicalRecord : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        console.log(checked, data, "checked")
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                              {
                                title: '是否回填上次就诊的病历信息',
                                key: 'isShowMedicalRecord',
                                dataIndex: "isShowMedicalRecord",
                                align: 'center',
                                width: '12rem',
                                render: function action(_, n: any) {
                                  return (
                                    <Switch
                                      checkedChildren='开启'
                                      unCheckedChildren='关闭'
                                      checked={n.isShowMedicalRecord}
                                      disabled={!n.isVisible}
                                      onChange={(checked) => {
                                        const data = functionsFieldConfig?.map((t: any) => {
                                          return {
                                            ...t,
                                            fields: t?.templateType === 'KQBL' ? t?.fields?.map((c: any) => {
                                              return {
                                                ...c,
                                                isShowMedicalRecord: n?.key === c?.key ? checked : c?.isShowMedicalRecord,
                                              }
                                            }) : t?.fields
                                          }
                                        })
                                        console.log(checked, data, "checked")
                                        setFunctionsFieldConfig(data)
                                      }}
                                    />
                                  )
                                },
                              },
                            ]}
                          />
                        </div>
                      </TabPane> :
                      <></>
                    }
                  </Tabs>
                </Row></> :
                <></>}
              {/* <div className={styles.modalTitle}>选择医嘱处方</div>
            <Row style={{ marginBottom: 20 }}>
              <Radio.Group value={1}>
                <Radio value={1}> 通用医嘱处方</Radio>
              </Radio.Group>
            </Row> */}
              <div className={styles.modalTitle}>处方类型设置</div>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              <Row style={{ marginBottom: 0 }} className={styles.checkboxRow}>
                <Form.Item
                  label='选择要开通的处方'
                  name={Checks.XZYKTDCF}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group
                    onChange={(e) => {
                      console.log(e,"e")
                      const dataList = e?.slice()
                      .sort((a: any, b: any) => getSortRecipeCategoryName(getRecipeCategoryName(a)) - getSortRecipeCategoryName(getRecipeCategoryName(b)))
                      setDefaultRecipeCategories(dataList)
                      const currentMrcfsz: any[] = form.getFieldValue(Checks.Mrcfsz) || []
                      form.setFieldsValue({
                        [Checks.Mrcfsz]: currentMrcfsz.filter((v: any) => e.includes(v))
                      })
                    }}
                    style={{ width: '100%' }}
                  >
                    {RecipeCategories.map((c) => {
                      return (
                        <Checkbox key={c} value={c} style={{ width: '20%' }}>
                          {getRecipeCategoryName(c)}
                        </Checkbox>
                      )
                    })}
                  </Checkbox.Group>
                </Form.Item>
              </Row>
              <Row style={{ marginBottom: 0 }} className={styles.checkboxRow}>
                <Form.Item
                  label='开方时默认自动创建处方'
                  name={Checks.Mrcfsz}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group style={{ width: '100%' }}>
                    {DefaultRecipeCategories.map((c: any) => {
                      return (
                        <Checkbox key={c} value={c} style={{ width: '20%' }}>
                          {getRecipeCategoryName(c)}
                        </Checkbox>
                      )
                    })}
                  </Checkbox.Group>
                </Form.Item>
              </Row>
            </>) : <></>}
          <div className={styles.modalTitle}>开方设置</div>
          <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
          {hisVersion == 0 ? (
            <>
              {/* <Row style={{ marginBottom: 0 }} className={styles.checkboxRow}>
                <Form.Item
                  label='开方选择库存设置'
                  name={''}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Radio.Group style={{ width: '100%' }}>
                    <Radio key={0} value={0} style={{ width: '25%' }}>
                      忽略库存开方
                    </Radio>
                    <Radio key={1} value={1} style={{ width: '25%' }}>
                      指定批次开方
                    </Radio>
                    <Radio key={2} value={2} style={{ width: '25%' }}>
                      不指定批次开方
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Row> */}
              <Row>
                <Form.Item
                  label='同步同组药品的频次/用法/天数'
                  name={Checks.Hbfz}
                  valuePropName='checked'
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox >开启
                    <Tooltip
                      placement="right"
                      title="开启后,同组药品的频次/用法/天数会保持一致,如不一致会自动调整,会以同组药品的第一个药为准"
                      trigger={['click']}
                    >
                      <QuestionCircleTwoTone style={{ marginLeft: '6px' }} />
                    </Tooltip></Checkbox>
                </Form.Item>

              </Row>
              {(formData?.includes(RecipeCategory.Tcm) || formData?.includes(RecipeCategory.TcmGranules)) ?
                <Row style={{ position: 'relative' }}>
                  <Form.Item
                    label='中药默认帖数'
                    name={Checks.MRts}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                    rules={[
                      {
                        pattern: /^[1-9]\d*$/,
                        message: '请输入大于0的整数',
                      },
                    ]}
                  >
                    <Input style={{ width: '24%' }}></Input>
                  </Form.Item>
                  <span style={{ position: 'absolute', right: '0', left: '46%', margin: '5px 0 0 10px' }}>帖</span>
                </Row>
                : <></>}
            </>) : <></>}
          <Row style={{ position: 'relative' }}>
            <Form.Item
              label='开方自动生成额外费用'
              name={Checks.Ewfy}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Checkbox.Group>
                <Checkbox value={1}>
                  开启
                  <Tooltip
                    placement="right"
                    title="开启后，在医生开方时会自动生成一个其他费用单，其他费用单里会自动添加设置好的诊疗费用"
                    trigger={['click']}
                  >
                    <QuestionCircleTwoTone style={{ marginLeft: '6px' }} />
                  </Tooltip>
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
            <Col span={8} style={{ position: 'absolute', left: '42%' }}>
              <Form.Item noStyle>
                <RecipeItemInput
                  isRestrictUser={1} //是否限制用户
                  style={{
                    width: '100%',
                    height: '2rem',
                    color: theme.tc1,
                  }}
                  placeholder='请输入诊疗项目'
                  autoFocus
                  type={2}
                  value={ewfyInput}
                  onSelect={(m, ignoreStorage) => {
                    setEwfyInput('')
                    setSelectedDiseases(selectedDiseases?.concat([{
                      id: m.id,
                      name: m.name,
                      price: m.retailPrice
                    }]))
                  }}
                  onChange={(v) => {
                    setEwfyInput(v)
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginLeft: '220px' }}>
            <Col
              style={{
                padding: '10px 10px 0 0px',
                marginBottom: 10,
              }}
            >
              {selectedDiseases?.map((d, index) => (
                <div key={index} className={styles.disease}>
                  {`${d.name}${d.price}`}{'元 '}
                  <CloseOutlined
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      const list = [...selectedDiseases]
                      list.splice(index, 1)
                      setSelectedDiseases(list)
                    }}
                  />
                </div>
              ))}
            </Col>
          </Row>
        </div>
        <Row justify='end' style={{ paddingTop: '10px' }}>
          <Button loading={btnLoading} type='primary' onClick={form.submit}>
            保存
          </Button>
        </Row>
      </Form>
    </Modal>
  )
}
